const crashlytics = () => ({
  recordError: () => undefined,
  log: () => undefined
});

export default crashlytics;
